const tokens = {
    IEX_TOKEN: `sk_4958766d79cd4a11aca701c07c83669c`,
    AlPHAV_TOKEN:`WPUW606G58525N9P`

}

// const IEX_TOKEN =`sk_4958766d79cd4a11aca701c07c83669c`
// const AlPHAV_TOKEN = `WPUW606G58525N9P`

export default tokens